import { createContext } from "react";

export const AthleteFormContext = createContext();
